import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Suspense, useEffect } from "react";
import { useAuth } from "../hooks/authBackoffice";
import GuardedRoute from "./GuardedRoute";
import { lazyWithRetry } from "../utils/lazyWithRetry";

// Lazy load dos componentes principais para code splitting
const BackofficeLayout = lazyWithRetry(
  () => import("../pages/Layout/base").then((module) => ({ default: module.Layout })),
  "backoffice-layout"
);
const BackofficeSignIn = lazyWithRetry(
  () => import("../pages/ProductsHomePage/index").then((module) => ({ default: module.ProductsHomePage })),
  "backoffice-signin"
);
const Logout = lazyWithRetry(
  () => import("../pages/Logout").then((module) => ({ default: module.Logout })),
  "backoffice-logout"
);
const SignUp = lazyWithRetry(
  () => import("../pages/SignUp").then((module) => ({ default: module.SignUp })),
  "backoffice-signup"
);

// Componente de loading
const RouteLoader = () => (
  <div style={{ 
    display: "flex", 
    justifyContent: "center", 
    alignItems: "center", 
    height: "100vh",
    backgroundColor: "#1a1d21"
  }}>
    <div style={{ color: "white", fontSize: "18px" }}>Carregando...</div>
  </div>
);

const BACKOFFICE_ROUTE = "/backoffice";
const LOGIN_ROUTE = "/signin/backoffice";

function RequireAuthBackoffice({ children }: { children: React.ReactElement }) {
  useEffect(() => {
    const session = sessionStorage.getItem("registerbackoffice");
    const hasAuthenticatedUser = localStorage.getItem("auth-storage") && localStorage.getItem("@backoffice:token");
    
    if (!session && !hasAuthenticatedUser) {
      // Só limpa o localStorage se não houver usuário autenticado
      localStorage.clear();
      sessionStorage.setItem("registerbackoffice", "2");
    } else if (!session) {
      // Se não tem session mas tem usuário autenticado, só marca a session
      sessionStorage.setItem("registerbackoffice", "2");
    }
  }, []);

  return children;
}

export function Router() {
  const { isAuthenticated, onLogout } = useAuth();

  return (
    <Suspense fallback={<RouteLoader />}>
      <Routes>
        {/* Rotas quando faz o login */}

        <Route
          element={
            <GuardedRoute
              isRouteAccessible={!isAuthenticated}
              redirectRoute={isAuthenticated ? BACKOFFICE_ROUTE : LOGIN_ROUTE}
            />
          }
        >
          <Route path="/" element={<BackofficeSignIn />} />
          <Route path="/cadastro" element={<SignUp />} />
        </Route>

        <Route element={<GuardedRoute isRouteAccessible={isAuthenticated} redirectRoute={"/"} />}>
          <Route
            path="/*"
            element={
              <RequireAuthBackoffice>
                <BackofficeLayout />
              </RequireAuthBackoffice>
            }
          >
          {/* <Route path="/backoffice/plans" element={<Plans />} />
            <Route path="/backoffice/transactions-pagbank" element={<TransactionsPagbank />} />
            <Route path="/backoffice/extracts-pagbank" element={<ExtractsPagbank />} />
            <Route path="/backoffice/signup-pf" element={<SignUpPfForBackoffice />} /> */}

          {/* <Route path="/backoffice/signup-pj" element={<SignUpPjForBackoffice />} /> */}

          {/* <Route path="/backoffice/forward-invoice-pagbank" element={<ForwardInvoicePagbank />} />
            <Route path="/backoffice/request-limits-users" element={<RequestLimitsWalllet />} />
            <Route path="/backoffice/transactions-pagbank/:id" element={<TransactionsPagbankDetails />} />
             */}
          {/* <Route index element={<HomeDash />} /> */}

          {/* <Route path="/backoffice/accounts" element={<Accounts />} />
            <Route path="/backoffice/get-transaction-delbank" element={<GetTrasactionsMaster />} />
            <Route path="/backoffice/accounts/wallet" element={<AccountsWallet />} />
            <Route path="/backoffice/accounts/ca" element={<AccountsCA />} />
            <Route path="/backoffice/accounts/:id" element={<Member />} />
            <Route path="/backoffice/upload/delbank/:id" element={<UploadDocumentsDelbank />} />
            <Route path="/backoffice/accounts/wallet/:id" element={<Wallet />} />
            <Route path="/backoffice/accounts/wallet/:id/extract" element={<WalletTransactions />} /> */}

          {/* <Route path="/backoffice/accounts/graphic/:id" element={<Graphic />} /> */}

          {/* <Route path="/backoffice/accounts/:id/tax" element={<AccountsDetailsTax />} />
            <Route path="/backoffice/accounts/wallet/:id/tax" element={<WalletDetailsTax />} /> */}

          {/* <Route path="/backoffice/transfers" element={<Transfers />} />

            <Route path="/backoffice/financial" element={<AccountsDetailsTransactions />} />

            <Route path="/backoffice/control-account" element={<ControlAccountsTransactions />} />
            <Route path="/backoffice/wallet/transactions" element={<TransactionsWallet />} />

            <Route path="/backoffice/accounts/:id/extract" element={<ContaAccounts />} />

            <Route path="/backoffice/config/persons" element={<ConfigPersons />} />
            <Route path="/backoffice/config/tax" element={<ConfigTax />} />
            <Route path="/backoffice/get-count-transactions" element={<CountTransactions />} />
            <Route path="/backoffice/config/tax/form" element={<FormConfigTax />} />
            <Route path="/backoffice/config/tax/form/:id" element={<FormConfigTax />} />
            <Route path="/backoffice/config/operators/form" element={<FormOperators />} />
            <Route path="/backoffice/config/operators/list" element={<ListOperators />} /> */}

            <Route path="logout" element={<Logout />} />
            {/* <Route path="/backoffice/tax" element={<TaxBackoffice />} />
              <Route path="/backoffice/support" element={<SupportBackoffice />} /> */}
          </Route>
        </Route>
        {/* <Route path="/logs/transactions/one" element={<LostTransactionsOneHour />} />
          <Route path="/logs/transactions/six" element={<LostTransactionsSixHours />} /> */}
      </Routes>
    </Suspense>
  );
}
